module.exports = __webpack_public_path__ + "img/cow_icon.e715f6d0.svg";